import React, { useCallback, useMemo } from 'react';
import { useRouter } from 'next/router';
import { Product } from '@commercetools/frontend-domain-types/product/Product';
// import { Variant } from '@loomstateorg/shared-frontend/types/product';
import { AUTOCOMPLETE_PRODUCT_CLICKED } from '@loomstateorg/shared-frontend/constants/events';
// import useVariantWithDiscount from '@loomstateorg/shared-frontend/hooks/useVariantWithDiscount';
import { Category } from '@loomstateorg/shared-frontend/types/category';
import Image from 'frontastic/lib/image';
import Link from '@loomstateorg/shared-frontend/components/commercetools-ui/atoms/link';
// import Prices from '@loomstateorg/shared-frontend/components/commercetools-ui/atoms/search/prices';

interface Props {
  hit: Product;
  categories: Category[];
  onClick?: () => void;
  index?: number;
}

const SearchItem: React.FC<Props> = ({ hit, categories, onClick, index = 0 }) => {
  const router = useRouter();

  const primaryCategory = useMemo(
    () => categories.find((category) => category.categoryId === process.env.NEXT_PUBLIC_WEB_CATEGORY_ID),
    [categories, hit],
  );

  const variant = useMemo(() => hit.variants?.[0], [hit]);
  // const discountedVariant = useVariantWithDiscount(hit.variants as Partial<Variant>[]);

  const handleClick = useCallback(() => {
    onClick?.();

    gtag('event', AUTOCOMPLETE_PRODUCT_CLICKED, hit);

    router.push(hit._url ?? '#');
  }, [hit, onClick, router]);

  return (
    <Link link={hit._url} onMouseUp={handleClick} data-testid={`atom-search-item-${index}`}>
      <div className="flex min-w-0 items-center gap-12">
        <div className="shrink-0 p-8">
          <div className="relative h-90 w-80">
            <Image alt="Image" src={variant?.images?.[0]} suffix="small" objectFit="contain" />
          </div>
        </div>
        <div className="min-w-0 flex-1">
          <p className="break-words text-16 uppercase text-primary-regular" data-testid={`atom-search-item-name-${index}`}>
            {hit.name}
          </p>
          <div className="mt-5">
            <span className="text-14 text-secondary-regular">{primaryCategory?.name}</span>
            {/* <Prices price={discountedVariant?.price ?? variant?.price} discountedPrice={discountedVariant?.price} /> */}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default SearchItem;
